import BoxLoader from "@3gaam/shared/components/general/boxLoader";
import Icon from "@3gaam/shared/components/general/icon";
import { RawResponsiveModal } from "@3gaam/shared/components/general/responsiveModal";
import useMediaQuery from "@3gaam/shared/hooks/useMediaQuery";
import React, { useEffect, useRef, useState } from "react";

type Props = {
  src: string;
  show: boolean;
  onClose?: () => void;
  title?: string;
};

const IframeModal = ({ src, show, onClose, title }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isMediaMatched = useMediaQuery(
    "(min-width: 485px) and (max-width: 585px)",
  );

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const refreshIframe = useRef<boolean>(false);

  useEffect(() => {
    let id: NodeJS.Timeout;

    if (show) {
      document.body.style.overflow = "hidden";
      refreshIframe.current = true;
    } else if (refreshIframe.current) {
      id = setTimeout(() => {
        iframeRef.current?.contentWindow?.location.reload();
        console.info("timeout reached");
      }, 2000);
    }

    return () => {
      document.body.style.overflow = "visible";
      id && clearTimeout(id);
    };
  }, [show]);

  return (
    <RawResponsiveModal show={show} onClose={onClose}>
      {isLoading && <BoxLoader type="cover" />}
      <div
        className="px-3 d-flex align-items-center justify-content-between w-full border-bottom bg-white"
        style={{
          minHeight: 60,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <h6 className="mr-3">{title}</h6>
        <div
          className="rounded-circle d-flex align-items-center justify-content-center bg-light"
          style={{
            width: 24,
            height: 24,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <Icon name="FA_R-xmark" />
        </div>
      </div>
      <iframe
        ref={iframeRef}
        src={src}
        id={src}
        className="border-none m-auto d-block"
        style={{
          width: isMediaMatched ? "484px" : "100%",
          height: "100%",
          minHeight: 600,
        }}
        onLoad={() => {
          setIsLoading(false);
        }}
      />
    </RawResponsiveModal>
  );
};

export default React.memo(IframeModal);
